/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partnerscolumnlunchmenus3Inputs */

const en_partnerscolumnlunchmenus3 = /** @type {(inputs: Partnerscolumnlunchmenus3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lunch menus`)
};

const de_partnerscolumnlunchmenus3 = /** @type {(inputs: Partnerscolumnlunchmenus3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mittagsmenüs`)
};

/**
* | output |
* | --- |
* | "Lunch menus" |
*
* @param {Partnerscolumnlunchmenus3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const partnerscolumnlunchmenus3 = /** @type {((inputs?: Partnerscolumnlunchmenus3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partnerscolumnlunchmenus3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_partnerscolumnlunchmenus3(inputs)
	return de_partnerscolumnlunchmenus3(inputs)
});
export { partnerscolumnlunchmenus3 as "partnersColumnLunchMenus" }